import { z } from 'zod';

export const BusinessFinancialDetailsFormSchema = () =>
  z
    .object({
      capitalStock: z.string().nullable(),
      ownFunds: z.string().nullable(),
      taxBase: z.string().nullable(),
      individualFinancialNetAmount: z.string().nullable(),
    })
    .strict();

export type BusinessFinancialDetailsFormType = z.infer<ReturnType<typeof BusinessFinancialDetailsFormSchema>>;
